import { DocumentIcon } from '@heroicons/react/24/outline';

import { UploadedFile } from 'src/shared/types/uploadedFile';
import { isImageMimeType } from 'src/shared/utils/fileTypeUtils';

import { Typography } from 'src/shared/components/ui';

interface RfqChatSentProps {
  text: string;
  files?: UploadedFile[];
  /** Callback when an image is clicked, receives the clicked image ID */
  onImageClick?: (imageId: string) => void;
}

const RfqChatSent = ({ text, files, onImageClick }: RfqChatSentProps) => {
  const handleImageClick = (file: UploadedFile) => {
    if (onImageClick) {
      onImageClick(file.id.toString());
    }
  };

  return (
    <div className="flex flex-col gap-2">
      {files && files.length > 0 && (
        <div className="flex justify-end">
          <div className="flex flex-col gap-2 items-end">
            {files.map((file) => (
              <div
                key={file.id}
                className="bg-gray-2 flex items-center gap-2 rounded-lg p-3 h-14 max-h-14 cursor-pointer hover:opacity-80 transition-opacity"
                onClick={() => handleImageClick(file)}
              >
                <div className="size-10 flex items-center justify-center flex-shrink-0">
                  {isImageMimeType(file.content_type) ? (
                    <img
                      src={file.url}
                      alt={file.name}
                      className="size-10 object-cover rounded cursor-pointer hover:opacity-80 transition-opacity"
                    />
                  ) : (
                    <DocumentIcon className="size-9 text-gray-500" />
                  )}
                </div>
                {file.description && (
                  <div className="flex flex-col gap-0">
                    <Typography
                      variant="body-2"
                      weight="medium"
                      className="text-gray-500"
                    >
                      {file.description}
                    </Typography>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      {text && (
        <div className="flex justify-end">
          <div className="max-w-[70%] px-4 py-2 rounded-3xl bg-gray-2">
            <Typography variant="body-1">{text}</Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default RfqChatSent;
